import React from "react";
import Authheader from "../../components/authheader";
import AuthVector from "../../assets/icons/auth-vector.svg";
import EyeIcon from "../../assets/icons/eye.svg";
import HideEyeIcon from "../../assets/icons/hideeye.svg";
import Input from "../../components/input";
import Button from "../../components/button";
import Loginwithgoogle from "../../components/loginwithgoogle";
import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signUp } from "../../store/slices/authSlice";
import toast from "react-hot-toast";

export default function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authLoader } = useSelector((state) => state.auth);
  const [signUpData, setSignupData] = useState({});
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  const [errors, setErrors] = useState({});

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setSignupData({ ...signUpData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validForm = () => {
    let Fromvlid = true;
    let errors = {};
    if (!signUpData.name?.trim()) {
      Fromvlid = false;
      errors["name"] = "Name is required*";
    }
    if (!signUpData.email?.trim()) {
      Fromvlid = false;
      errors["email"] = "Email Id is required*";
    } else {
      let lastAtPos = signUpData.email.lastIndexOf("@");
      let lastDotPos = signUpData.email.lastIndexOf(".");
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          signUpData.email.indexOf("@@") === -1 &&
          lastDotPos > 2 &&
          signUpData.email.length - lastDotPos > 2
        )
      ) {
        Fromvlid = false;
        errors["email"] = "Please enter valid Email ID";
      }
    }

    if (!signUpData.password?.trim()) {
      Fromvlid = false;
      errors["password"] = "Password is required*";
    } else if (signUpData.password.length < 8) {
      Fromvlid = false;
      errors["password"] = "Password must be at least 8 characters";
    }
    setErrors(errors);
    return Fromvlid;
  };

  const handleSignup = async () => {
    if (!validForm()) return;

    const result = await dispatch(signUp({
      name: signUpData.name,
      email: signUpData.email,
      password: signUpData.password,
    }));

    if (result?.payload?.data?.success) {
      toast.success("Account created! Please verify your email.");
      navigate("/verification-code", { state: { email: signUpData.email } });
    }
  };

  return (
    <div className="auth-layout">
      <div className="box">
        <Authheader />
        <div className="auth-body-alignment">
          <div className="grid">
            <div className="grid-items">
              <div className="image">
                <img src={AuthVector} alt="AuthVector" />
              </div>
            </div>
            <div className="grid-items">
              <div className="input-bottom-alignment">
                <Input label="Full Name" placeholder="Enter Your Full Name" name={"name"} onChange={handleOnChange} error={errors?.name} />
              </div>
              <div className="input-bottom-alignment">
                <Input label="Email" placeholder="Enter Your Email" name={"email"} onChange={handleOnChange} error={errors?.email} />
              </div>
              <Input
                type={showEyeIcon ? "text" : "password"}
                label="Password"
                name={"password"}
                placeholder="Enter Password"
                icon={showEyeIcon ? HideEyeIcon : EyeIcon}
                onChange={handleOnChange}
                error={errors?.password}
                iconClick={() => setShowEyeIcon(!showEyeIcon)}
              />

              <div className="signup-button-alignment">
                <Button text="Sign Up" onClick={handleSignup} loader={authLoader} />
              </div>
              <div className="text-grid">
                <div className="line"></div>
                <span>OR</span>
                <div className="line"></div>
              </div>
              <div className="google-contnet-alignment">
                <Loginwithgoogle />
              </div>
              <div className="last-text">
                <span>
                  You have an account ? <NavLink to="/login">Sign In</NavLink>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

